<div [ngStyle]="combinedStyles" [ngClass]="customClasses">
    <div
        #textBlock
        class="clamped-text"
        [class.overflowing]="isOverflowing"
        [class.expanded]="expanded"
        role="button"
        tabindex="0"
        (click)="onMoreClick($event)">
        {{ text }}
    </div>

    @if (expanded && collapsible) {
        <div role="button" tabindex="0" class="less-toggle" (click)="toggle()">{{ lessText }}</div>
    }
</div>
